import { SocketService } from './socket.service';
import { DataService } from './data.service';
var ChatService = (function () {
    function ChatService(_data, _socket) {
        this._data = _data;
        this._socket = _socket;
        this.socketType = 'msgSocket';
    }
    ChatService.prototype.open = function () {
        var deskId = this._data.session["desk"];
        this._socket.initSocket(deskId, this.socketType);
    };
    ChatService.prototype.close = function () {
        this._socket.clearSocket(this.socketType);
    };
    ChatService.prototype.sendMessage = function (message) {
        this._socket.send(message, this.socketType);
    };
    ChatService.prototype.onMessage = function () {
        return this._socket.getMessageObservable(this.socketType);
    };
    ChatService.prototype.onOpen = function () {
        return this._socket.getOpenObservable(this.socketType);
    };
    ChatService.prototype.onClose = function () {
        return this._socket.getCloseObservable(this.socketType);
    };
    return ChatService;
}());
export { ChatService };
